'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveChannel = undefined;

var _reselect = require('reselect');

var _getCurrentChannel = require('../conversationSelectors/getCurrentChannel');

var _getIsInForeground = require('./getIsInForeground');

var getActiveChannel = exports.getActiveChannel = (0, _reselect.createSelector)([_getIsInForeground.getIsInForeground, _getCurrentChannel.getCurrentChannel], function (isInForeground, currentChannel) {
  if (isInForeground) return currentChannel;
  return null;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/clientSelectors/getActiveChannel.js
// module id = 609
// module chunks = 2 3